import { Info, InfoOutlined, OpenInNew } from '@mui/icons-material'
import { ClickAwayListener, IconButton, Link, Paper, Tooltip, TooltipProps, Typography, styled, tooltipClasses } from '@mui/material'
import { useState } from 'react';
import { Link as RouterLink } from "react-router-dom";

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    margin: 0,
    padding: 0,
  },
}));

export const TooltipButton: React.FC<{
  title?: string,
  titleTwo?: string,
  text: string,
  textTwo?: string,
  placement: any,
  linkAnchorText?: string,
  linkURL?: string,
  noPadding?: boolean,
  textColor?: string,
}> = ({
  title,
  text,
  placement,
  linkAnchorText,
  linkURL,
  noPadding,
  textTwo,
  titleTwo,
  textColor,
}) => {

    const [active, setActive] = useState<boolean>(false);

    return (
      <StyledTooltip
        onClose={() => setActive(!active)}
        open={active}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={<ClickAwayListener onClickAway={() => setActive(false)}>
          <Paper sx={{ p: 2, minWidth: 300 }} elevation={3}>
            {title && <Typography variant='subtitle1' color='primary.main' sx={{ fontWeight: 600, pb: 1 }}>{title}</Typography>}
            <Typography variant='body2' color={textColor ?? 'text.primary'} sx={{ pb: (linkURL && linkAnchorText) && 2, whiteSpace: 'pre-wrap' }}>{text}
            </Typography>

            {titleTwo && <Typography variant='subtitle1' color='primary.main' sx={{ fontWeight: 600, pb: 1, mt: 2 }}>{titleTwo}</Typography>}
            {textTwo && <Typography variant='body2' color={textColor ?? 'text.primary'} sx={{ pb: (linkURL && linkAnchorText) && 2, whiteSpace: 'pre-wrap' }}>{textTwo}
            </Typography>}

            {(linkURL && linkAnchorText) &&
              <Link
                underline="hover"
                color="primary"
                to={linkURL}
                component={RouterLink}
                sx={{ fontSize: '1rem' }}
                target='_blank'
              >
                {linkAnchorText} <OpenInNew sx={{ fontSize: '1rem', verticalAlign: 'middle', pb: 0.5 }} />
              </Link>
            }
          </Paper>
        </ClickAwayListener>}
        placement={placement}
      >
        <IconButton
          disableRipple
          disableFocusRipple
          onClick={() => setActive(!active)}
          sx={{ "&:hover": { color: "primary.main" }, pt: 0, pb: 0, pr: noPadding ? 0 : 1 }}
          color={active ? 'primary' : 'default'}
        >
          {active ? <Info /> : <InfoOutlined />}
        </IconButton>
      </StyledTooltip>
    )
  }